 
<template>
    <b-card 
        no-body 
        :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" 
        :class="'mb-0 ' + ($store.getters['auth/preferDirIsRtl'] ? 'text-right' : 'text-left')"
    >
    <b-card-body class="d-flex justify-content-between align-items-center">
        <div class="truncate">
            <h2 class="mb-25 font-weight-bolder">
                {{ $t(title) }}
            </h2>
            <h5 v-if="description" >{{$t(description)}}</h5>

            <div class="d-flex justify-content-between align-items-center">
                <div 
                v-for="element in elements"
                class="card mb-0 box-shadow"
                >
                    <div class="card-header p-0 mx-1 mt-1 align-items-center justify-content-center">
                        <p class="font-weight-normal" >{{ $t(element.title) }}</p>
                    </div>
                    <div class="card-body text-center">
                        {{ element.value != undefined ? element.value : '-' }}
                    </div>
                </div>
            </div>

        </div>

        <b-avatar variant="light-success" size="45">
            <feather-icon size="21" :icon="icon" v-if="icon.endsWith('Icon')" />
            <img v-if="icon.endsWith('.svg')" :src="icon" width="30" :alt="$t(title)" />
        </b-avatar>
    </b-card-body>
</b-card>
</template>
  
<script>
import { 
    BCard, 
    BCardBody, 
    BAvatar
} from 'bootstrap-vue'
import { icon } from 'leaflet';
  
export default {
    components: {
        BCard, 
        BCardBody, 
        BAvatar
    },
    props:{
        title:{
            type:String
        },
        description:{
            type:String,
            default:null
        },
        elements:{
            type:Array
        },
        icon:{
            type:String,
            default:'InfoIcon'
        }
    },
    setup(props){
    }
}
</script>
   